import type { Period } from '../hooks/usePeriodParams';
import { revenueRecognitionApi } from './revenueRecognitionApi';

const COMPANY = 'PSN';

/** One unlock of a closed month — `Views/PeriodView.UnlockView` field for field. */
export interface PeriodUnlockView {
  unlockedBy: string;
  unlockedAt: string;
  reason: string;
}

/** `GET /periods`' answer — `Views/PeriodView` field for field. */
export interface PeriodView {
  id: string;
  company: string;
  year: number;
  month: number;
  /** `Open` or `Closed`. A month with no stored document reads Open, and there is no 404. */
  status: string;
  closedBy: string | null;
  closedAt: string | null;
  unlocks: PeriodUnlockView[];
}

export const periodStatusEndpoints = revenueRecognitionApi.injectEndpoints({
  endpoints: (builder) => ({
    getPeriodStatus: builder.query<PeriodView, Period>({
      query: ({ month, year }) => ({
        url: '/periods',
        method: 'GET',
        params: { company: COMPANY, month, year },
      }),
      providesTags: ['PeriodStatus'],
    }),
  }),
  overrideExisting: false,
});

export const { useGetPeriodStatusQuery } = periodStatusEndpoints;
